import { useEffect, useState } from 'react'
import { datadogRum } from '@datadog/browser-rum'

import * as newTailRepository from 'scripts/api/new-tail'

import { useDeviceType } from 'site/utils/useDeviceType'

const useProductsAds = props => {
  const {
    context,
    position,
    userId,
    sessionId,
    productId,
    categoryName,
    term
  } = props

  const [result, setResult] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const device = useDeviceType()

  useEffect(() => {
    if (Boolean(context) && Boolean(sessionId)) {
      setIsFetching(true)
      ;(async () => {
        try {
          const { data: result } = await newTailRepository.getProductsAds({
            context,
            position,
            productId,
            device,
            categoryName,
            term,
            userId,
            sessionId
          })

          setResult(result)
        } catch (e) {
          datadogRum.addError(e)
        } finally {
          setIsFetching(false)
        }
      })()
    }
  }, [
    categoryName,
    context,
    device,
    position,
    productId,
    sessionId,
    term,
    userId
  ])

  return { result, isFetching }
}

export default useProductsAds
